import { useEffect } from 'react'
import Navbar from '../../components/Navbar/Navbar'
import styles from './strPage.module.css'
import { useAppDispatch, useAppSelector } from '../../redux/types/types'
import { getStr } from '../../redux/actions/strAction'

type TopRow = {
  companyId: number
  companyName: string
  rank: number
  averageCheck: number
  loadingPercent: number
}

const formatCurrency = (value: number) =>
  value.toLocaleString('ru-RU', { minimumFractionDigits: 0 })

const StrPage = () => {
  const { companies } = useAppSelector((state) => state.str)
  const rows = companies
  const dispatch = useAppDispatch()
  const { token } = useAppSelector((state) => state.auth)

  useEffect(() => {
    if (token) {
      dispatch(getStr({ token }))
    }
  }, [token, dispatch])

  return (
    <div className={styles.strPageContainer}>
      <Navbar />
      <div className={styles.content}>
        <div className={styles.titleBlock}>STR рейтинг</div>

        <div className={styles.tableWrapper}>
          <table className={styles.table}>
            <thead className={styles.tableHead}>
              <tr className={styles.tableHeadRow}>
                <th className={styles.tableHeadCell}>Название компании</th>
                <th className={styles.tableHeadCell}>Место в топе</th>
                <th className={styles.tableHeadCell}>Средний чек (₽)</th>
                <th className={styles.tableHeadCell}>Загрузка (%)</th>
              </tr>
            </thead>
            <tbody className={styles.tableBody}>
              {rows.length > 0 ? (
                rows.map((row) => (
                  <tr key={row.companyId} className={styles.tableBodyRow}>
                    <td className={styles.tableBodyCell}>{row.companyName}</td>
                    <td className={styles.tableBodyCell}>{row.rank}</td>
                    <td className={styles.tableBodyCell}>{formatCurrency(row.averageCheck)}</td>
                    <td className={styles.tableBodyCell}>{row.loadingPercent}%</td>
                  </tr>
                ))
              ) : (
                <tr className={styles.emptyRow}>
                  <td className={styles.emptyCell} colSpan={4}>
                    Данные отсутствуют
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  )
}

export default StrPage
